import { cn } from '../lib/cn.js';
import { useOptionalTheme } from '../app/theme.jsx';

export function Brand({ dark, height = 30, className }) {
  const theme = useOptionalTheme();
  const useDarkWordmark = dark ?? theme?.resolvedTheme === 'dark';

  return (
    <span className={cn('brand-mark inline-flex', className)}>
      <img
        src={useDarkWordmark ? '/brand/step-only-dark.png' : '/brand/step-only.png'}
        alt="STEP"
        decoding="async"
        style={{ height, width: 'auto', display: 'block' }}
      />
    </span>
  );
}
